import React from 'react';
// import eventBanner from 'assets/img/generic/13.jpg';
import { Card, Row, Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import Calendar from 'components/common/Calendar';
// import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { jobUniqueId } from 'nursd-dashboard/utils/function';
// import paths from 'routes/paths';

const JobDetailHeader = ({ job }) => {
  // const eventInfo = {
  //   title: `FREE New Year's Eve Midnight Harbor Fireworks`,
  //   eventDate: { day: '31', month: 'Dec' },
  //   author: 'Boston Harbor Now',
  //   regFee: `$49.99 – $89.99`
  // };
  return (
    <Card className="p-0 mb-3">
      {/* {!!eventBanner && (
        <img className="card-img-top" src={eventBanner} alt="" />
      )} */}
      <Card.Body className="overflow-hidden">
        <Row className="flex-center">
          <Col>
            <Flex alignItems={'center'}>
              <Calendar
                month={moment(job?.startDate).format('MMM')}
                day={moment(job?.startDate).format('DD')}
                // {...eventInfo.eventDate}
              />
              <div className="fs-10 ms-2 flex-1">
                <h5 className="fs-9 text-capitalize">
                  {job?.jobType}-{job?.shiftTitle}
                </h5>
                <p className="mb-0 text-capitalize">
                  <h6>Posted by</h6>{' '}
                  {/* <Link className="ms-1" to={paths?.nursd_facility}> */}
                  {job?.manager?.name}
                  {/* </Link> */}
                </p>
                {job?.approved_manager && (
                  <p className="mb-0 text-capitalize">
                    <h6>Approved by</h6>{' '}
                    {/* <Link className="ms-1" to={paths?.nursd_facility}> */}
                    {job?.approved_manager?.name}
                    {/* </Link> */}
                  </p>
                )}
                {job?.closed_by && (
                  <p className="mb-0 text-capitalize">
                    Closed by {job?.closed_manager?.name}
                  </p>
                )}
              </div>
            </Flex>
          </Col>
          <Col md="auto" className="mt-4 mt-md-0">
            <h5
              className={`fs-9 text-center text-capitalize px-2 py-1`}
              style={{
                backgroundColor:
                  job?.jobStatus === 'Unfulfilled'
                    ? '#888'
                    : job?.jobStatus === 'Open' ||
                      job?.jobStatus === 'Pending Assignment'
                    ? '#ffff00'
                    : job?.jobStatus === 'Completed'
                    ? '#00b359'
                    : job?.jobStatus === 'Nurse Assigned' ||
                      job?.jobStatus === 'In-Progress' ||
                      job?.jobStatus === 'Pending Approval'
                    ? '#2775BD'
                    : job?.jobStatus === 'Missed' ||
                      job?.jobStatus === 'Pending Clock Out'
                    ? '#fc0505'
                    : '#888',
                color:
                  job?.jobStatus === 'Unfulfilled'
                    ? '#fff'
                    : job?.jobStatus === 'Open' ||
                      job?.jobStatus === 'Pending Assignment'
                    ? '#000'
                    : job?.jobStatus === 'Completed'
                    ? '#fff'
                    : job?.jobStatus === 'Nurse Assigned' ||
                      job?.jobStatus === 'In-Progress' ||
                      job?.jobStatus === 'Pending Approval'
                    ? '#fff'
                    : job?.jobStatus === 'Missed' ||
                      job?.jobStatus === 'Pending Clock Out'
                    ? '#fff'
                    : '#fff'
              }}
            >
              {job?.jobStatus}
              {job?.jobStatus === 'Missed' &&
                job?.pendingOrNoShowFacilityDecideMessage !== '' &&
                !job?.pendingOrNoShowFacilityDecideStatus && (
                  <span>-Not Approved</span>
                )}
              {job?.jobStatus === 'Pending Clock Out' &&
                job?.pendingOrNoShowFacilityDecideMessage !== '' &&
                !job?.pendingOrNoShowFacilityDecideStatus && (
                  <span>-Not Approved</span>
                )}
            </h5>
            <h5 className="fs-9 text-capitalize mt-2">
              {jobUniqueId(job?.id, job?.jobType)}
            </h5>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

JobDetailHeader.propTypes = {
  job: PropTypes.any
};

export default JobDetailHeader;
